<template>
  <div class="load-bar">
    <a-spin v-if="spinning"   tip="Loading...">
      </a-spin>
  </div>
</template>

<script type="text/ecmascript-6">
  export default {
    name: 'load',
    props: {

      spinning: {
        type: Boolean,
        default: false
      }
    }
  }
</script>
<style scoped lang='less' >
.load-bar{
  z-index: 9999999;
  display: flex;
  align-items: center;
 justify-content: center;
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left:0;
  background-color:rgba(255,255,255,0.5);
  transition: all 1s

}

</style>



